import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UserType {
  userID: string;
  name: string | null;
  email: string | null;
  role: "admin" | "customer" | null;
  type: string;
  theme: "light" | "dark";
  fontSize: "normal" | "large";
  lang: string;
  stripeID: string | null;
  subscription: string | null;
  lastLogin: Date;
  createdAt: Date;
  updatedAt: Date;
  trialPeriodEndAt: Date;
}

interface SettingsState {
  user: UserType | undefined;
}

const initialState: SettingsState = {
  user: undefined,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserType>) => {
      state.user = action.payload;
    },
    setUserTheme: (state, action: PayloadAction<"light" | "dark">) => {
      if (state.user === undefined) return;
      state.user.theme = action.payload;
    },
    setUserFontSize: (state, action: PayloadAction<"normal" | "large">) => {
      if (state.user === undefined) return;

      state.user.fontSize = action.payload;
    },
    setUserLang: (state, action: PayloadAction<string>) => {
      if (state.user === undefined) return;

      state.user.lang = action.payload;
    },
    setUserName: (state, action: PayloadAction<string | null>) => {
      if (state.user === undefined) return;
      state.user.name = action.payload;
    },
  },
});

export const {
  setUser,
  setUserTheme,
  setUserFontSize,
  setUserLang,
  setUserName,
} = settingsSlice.actions;
export default settingsSlice.reducer;
